module.exports = __webpack_public_path__ + "img/logo_200.9da5e525.svg";